export default __webpack_public_path__ + "static/media/m2.8d297589.png";